// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
/* eslint-disable */

require('@rails/ujs').start();
require('@rails/activestorage').start();
require('src/cocoon');

if (process.env.RAILS_ENV === 'development') {
  const jQuery = $ = require('jquery');

  global.$ = jQuery;
  global.jQuery = jQuery;
}

import 'select2';
import 'select2/dist/css/select2.css';

import 'jquery-mask-plugin';
import 'jquery-maskmoney/dist/jquery.maskMoney.js';

import ClipboardJS from 'clipboard';

import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/regular';

import './jquery.field_required_marker';
import applyDatepickerComponent from './apply_datepicker_component';

import '../stylesheets/application';

import './bootstrap_custom';

import bsCustomFileInput from 'bs-custom-file-input';

import '../../../node_modules/bootstrap-datepicker/dist/js/bootstrap-datepicker.min';
import '../../../node_modules/bootstrap-datepicker/dist/locales/bootstrap-datepicker.pt-BR.min';
import '../../../node_modules/bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';
import './addresses';
import './access_request';
import './certificate';
import './access_user/sign_in';
import './access_user/two_factor';
import './select2_input_filter';

/* eslint-disable */
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

/* eslint-disable */
FontAwesome.config.mutateApproach = 'sync';

const inputmask_cpf = '000.000.000-00';
const inputmask_cnpj = '00.000.000/0000-00';

$(document).ready(() => {
  const clipboard = new ClipboardJS('.btn');

  bsCustomFileInput.init();

  $('.custom-file-label').each(function () {
    const $self = $(this),
          $customFileWrapper = $self.parent(),
          $customFileInput = $customFileWrapper.children('input[type=file]');

    const files = $customFileInput.data('files');

    if (files) {
      $self.text(files);
    } else {
      $self.text('Nenhum arquivo selecionado');
    }

    const showLabel = $customFileInput.data('show-label');

    if (typeof (showLabel) !== 'undefined' && !showLabel) {
      $customFileWrapper.parent().children('label').first().remove();
    }
  })

  $('.custom-file-input').on('change', function() {
    const $self = $(this),
          $label = $self.parent().find('.custom-file-label');

    const hasNoSelection = $self.val().length === 0;

    if (hasNoSelection) {
      $label.text('Nenhum arquivo selecionado')
    }
  });

  // Toggle the side navigation
  $('#sidebarToggle').on('click', function (e) {
    e.preventDefault();

    $('body').toggleClass('sidebar-toggled');
    $('.sidebar').toggleClass('toggled');
  });

  // Prevent the content wrapper from scrolling when the fixed side navigation hovered over
  $('body.fixed-nav .sidebar').on('mousewheel DOMMouseScroll wheel', function (e) {
    if ($(window).width() > 768) {
      const e0 = e.originalEvent;
      const delta = e0.wheelDelta || -e0.detail;

      this.scrollTop += (delta < 0 ? 1 : -1) * 30;
      e.preventDefault();
    }
  });

  $('input[readonly]').on('click', function () {
    $(this).select();
  });

  $('.input--cpf').keypress(function () {
    $(this).mask(inputmask_cpf);
  });

  $('.input--cnpj').keypress(function () {
    $(this).mask(inputmask_cnpj);
  });

  $('.input--document').on('keyup', function () {
    var inputmask_document =
      this.value.replace(/\D/g, '').length < 11
        ? inputmask_cpf
        : inputmask_cnpj;

    $(this).mask(inputmask_document);
  });

  $('.input--mobile_number').mask('(00) 0000-00000');

  $('.input--mobile_number,.tel').on('keyup', function () {
    const value = this.value;

    if (typeof (value) !== 'undefined') {
      var inputmask_mobile_number =
        value.replace(/\D/g, '').length < 11
          ? '(00) 0000-00000'
          : '(00) 00000-0000';

      $(this).mask(inputmask_mobile_number);
    }
  });

  $('.input--cep').on('keypress', function () {
    $(this).mask('00000-000');
  });

  $('select.multiple_select').select2({
    theme: 'classic',
  });

  applyDatepickerComponent($('.datepicker'));

  $('.mask-money').each(function () {
    var $maskMoney = $(this),
      $form = $maskMoney.parents('form');

    $maskMoney
      .attr('type', 'tel')
      .maskMoney({
        thousands: '.',
        decimal: ','
      });

    $maskMoney.maskMoney('mask', parseFloat($maskMoney.val()));

    $form.on('submit', function () {
      var value = parseFloat($maskMoney.maskMoney('unmasked')[0]).toFixed(2);

      $maskMoney.val(value);
      $maskMoney.maskMoney('destroy');

      return true
    });
  });
});

// Scroll to top button appear
$(document).on('scroll', function () {
  const scrollDistance = $(this).scrollTop();

  if (scrollDistance > 100) {
    $('.scroll-to-top').fadeIn();
  } else {
    $('.scroll-to-top').fadeOut();
  }
});
/* eslint-disable */
